<template>
    <div class="modal fade" id="modal_global" tabindex="-1" aria-labelledby="exampleModalGlobalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div :class="`modal-content bg-${getColorMode.background} text-${getColorMode.text}`">
              <div :class="`modal-header bg-${getColorMode.globalBackground} text-${getColorMode.text} border-0 shadow-sm`">
                  <h5 class="modal-title" id="exampleModalGlobalLabel"> {{ modalTitle }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                {{ modalText }}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="action">Duplicar</button>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Modal } from 'bootstrap'
  export default {
    name: 'ModalGlobal',
    emits: ['closeModal', 'duplicateFolder'],
    props: {
      modalTitle: {type: String, default: ''},
      modalText: {type: String, default: '¿Estás seguro de realizar esta acción?'},
      modalType: {type: String, default: ''}
    },
    data(){
      return {
        modal: null,
      }
    },
    mounted(){
      this.modal = new Modal(document.getElementById('modal_global'), {})
      this.modal.show()
      let app = this
      document.getElementById('modal_global').addEventListener('hide.bs.modal', function () {
        app.$emit('closeModal')
      })
    },
    methods: {
      action(){
        let app = this
        switch(app.modalType){
          case 'duplicateData':
            app.$emit('duplicateFolder')
            break
        }
      }
    },
    computed: {
      ...mapGetters('general', ['getColorMode']),
    }
  }
</script>
